export default __webpack_public_path__ + "static/media/img_upee.4d452c3b.webp";